import { createSlice } from "@reduxjs/toolkit";

interface ViewState {
    isMobileView: boolean;
}

const initialState: ViewState = {
    isMobileView: window.innerWidth < 900,
};

const viewSlice = createSlice({
    name: "view",
    initialState,
    reducers: {
        setIsMobileView(state, action) {
            state.isMobileView = action.payload;
        },
    },
});

export const { setIsMobileView } = viewSlice.actions;
export default viewSlice.reducer;
